import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { ImageUpload } from "@/components/ImageUpload";
import { Field } from "@/components/admin/kit";

const sel = "h-9 w-full rounded-md border bg-white px-2 text-sm";

function Row({ label, checked, onChange, testid }) {
  return <label className="flex items-center justify-between gap-3 text-sm py-1.5">{label}<Switch checked={checked} onCheckedChange={onChange} data-testid={testid} /></label>;
}

function Steps({ t, up, scenes }) {
  const steps = t.glide_steps || [];
  const set = (i, patch) => up({ glide_steps: steps.map((s, j) => (j === i ? { ...s, ...patch } : s)) });
  return (
    <div className="space-y-2 mt-2" data-testid="tdv-glide-steps">
      {steps.map((s, i) => (
        <div key={i} className="rounded-2xl border p-3 space-y-2" data-testid={`tdv-glide-step-${i}`}>
          <div className="flex gap-2">
            <select className={sel} value={s.media_id} onChange={(e) => set(i, { media_id: e.target.value })} data-testid={`tdv-glide-scene-${i}`}>
              {scenes.map((sc) => <option key={sc.id} value={sc.id}>{t.scene_names?.[sc.id] || sc.label}</option>)}
            </select>
            <select className={`${sel} w-20`} value={s.hold} onChange={(e) => set(i, { hold: +e.target.value })} data-testid={`tdv-glide-hold-${i}`}>
              {[3, 4, 5, 6, 8, 10].map((n) => <option key={n} value={n}>{n}s</option>)}
            </select>
            <button type="button" onClick={() => up({ glide_steps: steps.filter((_, j) => j !== i) })} className="shrink-0 w-9 h-9 rounded-full hover:bg-rose-50 text-rose-600 grid place-items-center" data-testid={`tdv-glide-remove-${i}`}><Trash2 className="w-4 h-4" /></button>
          </div>
          <Input className="h-9 text-sm" value={s.text} maxLength={160} onChange={(e) => set(i, { text: e.target.value })} placeholder="Caption, e.g. Wake up to lake views" data-testid={`tdv-glide-text-${i}`} />
        </div>
      ))}
      {steps.length < 8 && scenes.length > 0 && (
        <button type="button" onClick={() => up({ glide_steps: [...steps, { media_id: scenes[Math.min(steps.length, scenes.length - 1)].id, text: "", hold: 5 }] })} className="text-sm font-semibold text-bp inline-flex items-center gap-1.5" data-testid="tdv-glide-add"><Plus className="w-4 h-4" /> Add a line</button>
      )}
    </div>
  );
}

export function TdvPresentation({ t, up, scenes }) {
  return (
    <div className="rounded-3xl bg-white border p-5 space-y-3" data-testid="tdv-presentation">
      <p className="font-semibold">Presentation</p>
      <Field label="About this tour (start screen and AI assistant)"><Textarea rows={3} maxLength={3000} value={t.description || ""} onChange={(e) => up({ description: e.target.value })} placeholder="What it is, where it is, what makes it special" data-testid="tdv-description" /></Field>
      <Field label="Start screen photo"><ImageUpload value={t.photo_url || ""} onChange={(v) => up({ photo_url: v })} testid="tdv-photo" /></Field>
      <Field label="AI assistant welcome"><Input maxLength={300} value={t.chat_welcome || ""} onChange={(e) => up({ chat_welcome: e.target.value })} placeholder={`Welcome to ${t.name}. Ask me anything.`} data-testid="tdv-chat-welcome" /></Field>
      <Row label="Start screen" checked={t.start_screen !== false} onChange={(v) => up({ start_screen: v })} testid="tdv-toggle-start" />
      <Row label="Cinematic opening" checked={!!t.intro_glide} onChange={(v) => up({ intro_glide: v })} testid="tdv-toggle-glide" />
      {t.intro_glide && <><Row label="Closing card" checked={t.closing_card !== false} onChange={(v) => up({ closing_card: v })} testid="tdv-toggle-closing" /><Steps t={t} up={up} scenes={scenes} /></>}
    </div>
  );
}
